import type {
  IBiggestCountCasesDto,
  IBonusPiecesDto,
  IDropItemDto,
  IMotivatorDto,
  IMotivatorStatistic,
  IMotivatorTop24Item,
  IMotivatorType,
  IP2pItemCreated,
  IUpgraderItem,
  MotivatorSocketKeys,
} from '@dev-fast/types';

export interface ILobbyMotivatorQueueItem {
  motivator: IMotivatorDto<IDropItemDto>;
  addToBestDropsListAll: boolean;
}

export interface IMotivatorStateModel {
  bestLastResult: IMotivatorTop24Item[];
  bestDrop: IMotivatorDto<IDropItemDto> | null;
  bigOpens: IBiggestCountCasesDto | null;
  marketList: Array<IMotivatorDto<IP2pItemCreated>>;
  bestDropsList: Array<IMotivatorDto<IDropItemDto>>;
  bestDropsListAll: Array<IMotivatorDto<IDropItemDto>>;
  bestUpgradesList: Array<IMotivatorDto<IUpgraderItem>>;
  lobbyCasesMotivator: IMotivatorStatistic;
  lobbyMotivatorQueue: ILobbyMotivatorQueueItem[];
  isLobbyQueueDraining: boolean;
  lobbyQueueGeneration: number;
  caseId: number | null;
  bestLastShardsDropList: Array<IMotivatorDto<IBonusPiecesDto>>;
  currentCaseMotivator: IMotivatorStatistic;
  isCaseMotivatorHidden: boolean;
  isPlayback: boolean;
  isSubscribedToLastWon: boolean;
  lastDropsList: Array<IMotivatorDto<IDropItemDto>>;
  lastUpgradesList: Array<IMotivatorDto<IUpgraderItem>>;
  lastTicketsItemsList: Array<IMotivatorDto<IDropItemDto>>;
  bestTicketsItemsList: Array<IMotivatorDto<IDropItemDto>>;
  activeSockets: MotivatorSocketKeys[];
  topUsers: IMotivatorType | null;
  casesLast: Array<IMotivatorDto<IDropItemDto>>;
  upgradesLast: Array<IMotivatorDto<IUpgraderItem>>;
  challengesLast: Array<IMotivatorDto<IDropItemDto>>;
}

export const MOTIVATOR_INITIAL_STATE: IMotivatorStateModel = {
  bestLastResult: [],
  bestDrop: null,
  bigOpens: null,
  bestDropsList: [],
  bestDropsListAll: [],
  bestUpgradesList: [],
  bestLastShardsDropList: [],
  caseId: null,
  currentCaseMotivator: { bestLast: [] },
  isCaseMotivatorHidden: false,
  lobbyCasesMotivator: { bestLastAll: [] },
  lobbyMotivatorQueue: [],
  isLobbyQueueDraining: false,
  lobbyQueueGeneration: 0,
  isPlayback: true,
  isSubscribedToLastWon: true,
  lastDropsList: [],
  lastUpgradesList: [],
  lastTicketsItemsList: [],
  bestTicketsItemsList: [],
  activeSockets: [],
  topUsers: null,
  casesLast: [],
  upgradesLast: [],
  challengesLast: [],
  marketList: [],
};
